module.exports = __webpack_public_path__ + "index/img/tab1Current2.1d6d9254.png";